import React from 'react';
import styled, { css } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import useFooterMenuItems from 'gatsby-theme-menus/src/hooks/use-footer-menu-items';
import useOpeningHours from 'gatsby-theme-core/src/hooks/use-opening-hours';
import Socials from '../socials';
import SocialsTitle from './socials-title';
import NavLink from './nav-link';
import SocialsWrapper from './socials-wrapper';
import Item from './item';
import Title from './title';

const Footer = () => {
  const { menus } = useFooterMenuItems();
  const { hasOpeningHours, byLine } = useOpeningHours();

  // we we dont have the opening hours
  // and one or two menus
  // we will use double columns on the first menu
  const doubleColumnOnFirstMenu = !hasOpeningHours
    && ((menus.length > 0) && (menus.length < 3));

  return (
    <StyledFooter>
      <Container>
        <InnerFooter>
          {menus.map((menu, index) => (
            <Item
              key={menu.id}
              toggle
              title={menu.title || 'Menu'}
              columns={doubleColumnOnFirstMenu && (index === 0)}
            >
              <FooterNav columns={doubleColumnOnFirstMenu && (index === 0)}>
                {menu.items.filter(Boolean).map(({ page }) => {
                  const { id, slug, title } = page;
                  return (
                    <li key={id}>
                      <NavLink to={slug}>{title}</NavLink>
                    </li>
                  );
                })}
              </FooterNav>
            </Item>
          ))}

          {hasOpeningHours && (
            <Item toggle title={byLine[0].title || 'Openingstijden'}>
              {byLine.map(({ title, lines }, index) => (
                <div key={title || `openingtijden-${index}`}>
                  {index !== 0 && (
                    <Title>{title}</Title>
                  )}
                  <Table>
                    <tbody>
                      {(lines || []).map((line) => (
                        <tr key={line.title}>
                          <td>{line.title}</td>
                          <td>{line.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ))}
            </Item>
          )}

          <Item>
            <SocialsWrapper>
              <SocialsTitle />
              <Socials variant="footer" />
            </SocialsWrapper>
          </Item>
        </InnerFooter>
      </Container>
    </StyledFooter>
  );
};

const Table = styled.table`
  td {
    padding: 8px 0;

    &:first-child {
      padding-right: 1rem;
    }
  }
`;

const StyledFooter = styled.footer`
  color: white;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
`;

const InnerFooter = styled.div`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: flex;
    grid-gap: ${(props) => props.theme.grid.gap};
    align-items: baseline;
  }
`;

const FooterNav = styled.ul`
  margin: 0;
  padding: 0;

  ${({ columns }) => columns && css`
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      column-count: 2;
    }
  `}

  li {
    list-style: none;
  }
`;

export default Footer;
